﻿import {Core} from "../../Base/Core";
import {Reward} from "../../Data/GameData";
import {NUtils} from "../../Utils/NUtils";
import {UISprite} from "../Tools/Base/UISprite";
import {UIText} from "../Tools/Base/UIText";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";
import {RewardedAdsBtn} from "../RewardedAdsBtn";

export class UITapChallengeVictory extends UICommonPopup {
    Awake() {
        super.Awake();

        this.onClickTake = this.onClickTake.bind(this);
        this.onClickTakeMore = this.onClickTakeMore.bind(this);
        this.onShown = this.onShown.bind(this);

        this.icon = this.content.addChild(new UISprite("bank/pack-gold-safe"));

        this.totalRewardTitle = this.content.addChild(new UIText(Core.Localizator.Get("tap_challenge_your_reward")));

        this.totalRewardField = this.content.addChild(
            new UILabeledIcon({
                label: "",
                icon: "ico-gold",
                iconAlign: "left",
                iconSize: 0.6,
                textProps: { fontSize: 80 },
            })
        );

        this.takeBtn = this.content.addChild(
            new UINineSliceButton("btn-green", {
                label: Core.Localizator.Get("take"),
            })
        );

        this.takeMoreBtn = this.content.addChild(
            new RewardedAdsBtn("btn-blue", {
                icon: "play-icon",
                iconAlign: "left",
                label: Core.Localizator.Get("take"),
            })
        );
        this._reward = null; // Reward
    }

    Init() {
        super.Init();
        this.takeBtn.on("pointertap", this.onClickTake);
        this.takeMoreBtn.on("pointertap", this.onClickTakeMore);
    }

    onClickTakeMore() {
        Core.Ads.TriggerRewarded(this.onShown);
    }

    onShown() {
        this._reward.value *= BigInt(Core.GameData.TapChallenge.rewardMultiplyRate);
        this._reward.Take("TapChallengeMultiplyReward");
        this.Hide();
    }

    onClickTake() {
        this._reward.Take("TapChallenge1x");
        Core.Ads.TriggerInterstitial();
        this.Hide();
    }

    Show(reward) {
        console.log("TAP CHALLENGE WIN", reward.value);
        this.fitLayout();
        super.Show();
        this.takeMoreBtn.label = Core.Localizator.Get("take_x", Core.GameData.TapChallenge.rewardMultiplyRate);
        this._reward = new Reward();
        this._reward.value =
            BigInt(~~reward.value || 0) *
            BigInt(~~GameManager.gameController.MoneySoftSpeed) *
            BigInt(~~Core.GameData.Planets.GetPlanet(Core.Player.PlanetsSave.CurrentPlanet.planetId).tapIncomeMultiplayer);
        this._reward.type = reward.type;

        this.totalRewardField.label = NUtils.FormatMoney(this._reward.value);
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.4;
        let w = Math.min(viewport.width * 0.6, (viewport.height * 0.6) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h));

        super.fitLayout(viewport);

        let popupRect = this.getContentSize();

        let rect = popupRect.clone();
        rect.height = popupRect.height * 0.35;
        rect.width = popupRect.width * 0.7;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0;
        this.icon.fitRect(rect, true);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.16;
        rect.width = popupRect.width * 0.75;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.48;
        this.totalRewardTitle.fitLayout(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.8;
        rect.height = popupRect.height * 0.2;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.72;
        this.totalRewardField.fitLayout(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.41;
        rect.height = popupRect.height * 0.16;
        rect.x = (popupRect.width - rect.width) * 0.11;
        rect.y = (popupRect.height - rect.height) * 0.95;
        this.takeBtn.fitLayout(rect);

        rect.x = (popupRect.width - rect.width) * 0.89;
        this.takeMoreBtn.fitLayout(rect);
    }
}
